"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SINGLE_CREDIT_NOTE = void 0;

var _singleCreditNote = require("./singleCreditNote");

var _tabs = require("./tabs");

var _approveModal = require("./approveModal");

var _deleteModal = require("./deleteModal");

var _editProductModal = require("./editProductModal");

var _editNonStockCreditModal = require("./editNonStockCreditModal");

var _editWarehouseModal = require("./editWarehouseModal");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SINGLE_CREDIT_NOTE = _objectSpread(_objectSpread({}, _singleCreditNote.SINGLE_CREDIT_NOTE), {}, {
  TABS: _tabs.TABS,
  APPROVE_MODAL: _approveModal.APPROVE_MODAL,
  DELETE_MODAL: _deleteModal.DELETE_MODAL,
  EDIT_PRODUCT_MODAL: _editProductModal.EDIT_PRODUCT_MODAL,
  EDIT_NON_STOCK_CREDIT_MODAL: _editNonStockCreditModal.EDIT_NON_STOCK_CREDIT_MODAL,
  EDIT_WAREHOUSE_MODAL: _editWarehouseModal.EDIT_WAREHOUSE_MODAL
});

exports.SINGLE_CREDIT_NOTE = SINGLE_CREDIT_NOTE;